// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#000428, #004e92",
  firstName: "Yaswanth",
  middleName: "",
  lastName: "Modepalli",
  message: "Life's joy, writing clean code adds a spark to it ⚡",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/Yaswanth14",
    },
    {
      image: "fa-instagram",
      url: "https://www.instagram.com/_yaswanth14/",
    },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/Yaswanth14/",
    },
    {
      image: "fa-twitter",
      url: "https://www.twitter.com/YModepalli/",
    },
    {
      image: "fa-centercode",
      url: "https://ymodepalli.hashnode.dev/"
    }
  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/hashirshoaeb.png"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/pic.jpg"), 
  imageSize: 375,
  message:
    "Hey, I'm Yaswanth an aspiring Full Stack developer with a flair for turning caffeine into code. I like to play, travel, code and create. Working with a team full of passionate and visionary folks is what I look forward for. Ask me about Python, JavaScript, Django, Express, and Node. I'm currently exploring React, feel free to join me in my jouney by following me on my twitter ❤",
  resume: "https://drive.google.com/file/d/1S-FSDkf6U9UIc-7jMkzxlV7cVmFqLCkj/view?usp=sharing",
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: true,
  heading: "Latest repos on my GitHub",
  gitHubUsername: "Yaswanth14", //i.e."johnDoe12Gh"
  reposLength: 2,
  specificRepos: ["Salary-Analysis", "snoozeWrites"],
};

// Leadership SECTION
const leadership = {
  show: false,
  heading: "Leadership",
  message:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae auctor eu augue ut lectus arcu bibendum at varius. Libero justo laoreet sit amet cursus sit amet. Imperdiet dui accumsan sit amet nulla facilisi morbi. At auctor urna nunc id. Iaculis urna id volutpat lacus laoreet non curabitur gravida. Et magnis dis parturient montes nascetur ridiculus mus mauris. In nisl nisi scelerisque eu ultrices vitae auctor. Mattis nunc sed blandit libero volutpat sed cras ornare. Pulvinar neque laoreet suspendisse interdum consectetur libero.",
  images: [
    { 
      img: require("../editable-stuff/pic.jpg"), 
      label: "First slide label", 
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    },
    { 
      img: require("../editable-stuff/pic.jpg"), 
      label: "Second slide label", 
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    },
  ],
  imageSize: {
    width:"615",
    height:"450"
  }
};

// SKILLS SECTION
const skills = {
  show: false,
  heading: "Skills",
  hardSkills: [
    { name: "Python", value: 70 },
    { name: "SQL", value: 65 },
    { name: "Data Structures", value: 85 },
    { name: "C/C++", value: 75 },
    { name: "JavaScript", value: 80 },
    { name: "Django", value: 65 },
    { name: "HTML/CSS", value: 55 },
    { name: "Git", value: 80 },
  ],
  softSkills: [
    { name: "Goal-Oriented", value: 80 },
    { name: "Collaboration", value: 90 },
    { name: "Positivity", value: 75 },
    { name: "Adaptability", value: 85 },
    { name: "Problem Solving", value: 75 },
    { name: "Empathy", value: 90 },
    { name: "Organization", value: 70 },
    { name: "Creativity", value: 90 },
  ],
};

//Education

const education = {
  show: false,
  heading: "Education",
  lists: [
    {
      university: "Gayatri Vidya Parishad College of Engineering",
      degree: "Bachelor of Technology in Computer Science (Data Science)",
      time: "January 2021 - Present",
      description:"With no background in Computer Science I had a great learning experience along this time, I've been exposed to diverse set of people including students and working proffesionals, have involved in multiple communities and hackathons"
    },
    {
      university: "S. V. K. Junior College",
      degree: "Intermediate in Maths, Physics, and Chemistry",
      time: "June 2018 - April 2020",
      description:"Met amazing friends to chill out with! Developed a strong foundation in the fundamentals of Maths, which has helped me in my subsequent studies and career."
    }]
  };

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
    "I love turning ideas into real life products. If you want to hire me for a gig, or just want to say hi, please feel free to email me at",
  email: "yaswanth0614@gmail.com",
};

const experiences = {
  show: false,
  heading: "Experiences",
  data: [
    {
      role: 'Project Intern',// Here Add Company Name
      companylogo: require('../assets/img/bhel.png'),
      date: 'December 2023 – Jan 2024',
    },
  ]
}

// Blog SECTION
// const blog = {
//   show: false,
// };

export { navBar, mainBody, about, repos, skills, education, leadership, getInTouch, experiences };
